import clsx from 'clsx'
import { useField } from 'formik'

import { ReactComponent as ArrowIcon } from 'public/assets/icons/chevron-right.svg'

interface Props {
  name: string
  options: {
    label: string
    value: string
    icon?: React.FC
  }[]
  className?: string
}

function RadioField({ name, options, className }: Props): JSX.Element {
  const [field, meta] = useField<string>(name)

  return (
    <div className={className}>
      {options.map(option => {
        const isChecked = field.value.includes(option.value)
        return (
          <div key={option.value} className="relative">
            <input
              {...field}
              type="radio"
              id={`form-${option.value}`}
              value={option.value}
              className="tap-transparent peer | absolute | opacity-0 | w-full h-full | cursor-pointer"
              checked={isChecked}
            />
            <label
              htmlFor={`form-${option.value}`}
              className={clsx(
                'text-paragraph-4 font-medium | flex items-center justify-between gap-3 | border border-gray-30 rounded-xl shadow-sm | px-6 py-3 | peer-focus-visible:ring-1',
                isChecked && 'text-blue-50 bg-blue-10 border-blue-30'
              )}
            >
              <span className="flex items-center gap-4">
                {option.icon && <option.icon />}
                {option.label}
              </span>
              <ArrowIcon className="shrink-0" />
            </label>
          </div>
        )
      })}

      {meta.touched && meta.error ? (
        <div className="text-small font-medium text-orange-50  |  mt-2">
          {meta.error}
        </div>
      ) : null}
    </div>
  )
}

export default RadioField
